export const serializeSvg = (svgElement: SVGElement): string => {
  return new XMLSerializer().serializeToString(svgElement);
};

export const createSvgBlob = (svgData: string): Blob => {
  return new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
};
